import { classes } from "portal/theme/theme";
import { SvgIcon, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import CarbonLogo from "portal/images/logo_icon_border.svg?react";
import React, { FunctionComponent } from "react";

interface MetricInternalIconProps {
  className?: string;
}

export const MetricInternalIcon: FunctionComponent<MetricInternalIconProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <span className={classes("leading-[0]", className)}>
      <Tooltip arrow title={t("utils.metrics.internal")}>
        <SvgIcon fontSize="inherit">
          <CarbonLogo className="w-10 h-10 text-carbon-orange" />
        </SvgIcon>
      </Tooltip>
    </span>
  );
};
